// extracted by mini-css-extract-plugin
module.exports = {"cancel_btn":"GlobalCancelBtn_cancel_btn__4Jq_V"};